exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1dntvE9BGQxTM25IBS24qj{display:table}.No6CM2UJbJO5ijpxdCxVy{display:table-row}._1NNmGereLyUNYPfwtukcyK,.Xlc9klE5vdi3TEwf4u2Fg{display:table-cell}html[dir=ltr] .Xlc9klE5vdi3TEwf4u2Fg{padding-left:10px}html[dir=rtl] .Xlc9klE5vdi3TEwf4u2Fg{padding-right:10px}html[dir] ._2gDXe2z7UYce3W6qBh_3gB{margin-top:20px}", ""]);

// exports
exports.locals = {
	"propertyContainer": "_1dntvE9BGQxTM25IBS24qj",
	"propertyRow": "No6CM2UJbJO5ijpxdCxVy",
	"propertyName": "_1NNmGereLyUNYPfwtukcyK",
	"propertyValue": "Xlc9klE5vdi3TEwf4u2Fg",
	"okButton": "_2gDXe2z7UYce3W6qBh_3gB"
};